import { inject } from '@angular/core';
import {
  Router,
  type ActivatedRouteSnapshot,
  type CanActivateFn,
} from '@angular/router';

import { AuthSelectorsFacade } from '@ps/auth-data-access';

import { UserSettingsSelectorsFacade } from '../state/user-settings.selectors.facade';
import { canAccess } from '../utils/role-access.helper';
import type { BuyerSettings } from '../models/settings.model';

export const featureFlagGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const auth = inject(AuthSelectorsFacade);
  const userSettings = inject(UserSettingsSelectorsFacade);
  const router = inject(Router);

  const redirectTo: string = route.data['redirectTo'] ?? '/not-found';
  const flagName: keyof BuyerSettings | undefined = route.data['flagName'];

  if (!flagName) {
    return router.parseUrl('/not-found');
  }

  const hasAccess = canAccess({
    userType: auth.userType(),
    userAccessLevel: auth.userAccessLevel(),
    config: { flagName },
    buyerSettings: userSettings.buyerSettings(),
  });

  return hasAccess ? true : router.parseUrl(redirectTo);
};
